import React, { useState, useEffect } from "react";
import { Home } from "./Home";
import { Login } from "./Login";
import { validateConfig } from "../helpers/auth-helper";
import { getSrcPath } from "../helpers/auth-helper";
const Landing = /*#__PURE__*/React.memo(_ref => {
  let {
    navigate,
    member_id,
    member_name,
    pulse_token,
    onSignIn
  } = _ref;
  const validateHeader = validateConfig();
  const hostSrc = getSrcPath();
  const body = JSON.stringify({
    member_id,
    pulse_token
  });
  const [jwtToken, setJwtToken] = useState(null);
  const [loader, setLoader] = useState(true);
  useEffect(() => {
    // localStorage.removeItem("jwtToken");
    localStorage.setItem("memberName", member_name);
    const fetchData = async () => {
      const url = hostSrc + "/v1/gis/bial/generate/member/token/";
      const headers = validateHeader;
      try {
        const response = await fetch(url, {
          method: "POST",
          headers: headers,
          body: body
        });
        const data = await response.json();
        localStorage.setItem("jwtToken", data.member_token);
        localStorage.setItem("memberId", member_id);
        setJwtToken(data.member_token);
        setLoader(false);
      } catch (error) {
        console.error("Error:", error);
        setLoader(false);
      }
    };
    if (member_id != "" && member_id != undefined && member_id != null && pulse_token != "" && pulse_token != undefined && pulse_token != null) {
      fetchData();
    } else {
      setLoader(false);
    }
  }, []);
  const value = localStorage.getItem("jwtToken");
  if (value && value.substring(0, 3) == "JWT") {
    return /*#__PURE__*/React.createElement(Home, {
      navigate: navigate
    });
  } else {
    return /*#__PURE__*/React.createElement("div", null, loader ? /*#__PURE__*/React.createElement("div", {
      style: {
        backgroundColor: "#131e1e",
        minHeight: "850px",
        maxWidth: "425px",
        margin: "auto"
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "login-loader",
      style: {
        display: "flex",
        justifyContent: "center",
        paddingTop: "150px"
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: "https://images.ctfassets.net/vel1ejdzohgb/6oUWoUvFL1l3ln6DXS5FVS/627a4af97944db10804e10ef957a4208/loader.png",
      style: {
        height: "250px"
      }
    }))) : /*#__PURE__*/React.createElement(Login, {
      onSignIn: onSignIn,
      navigate: navigate
    }));
  }
});
export { Landing };